import { NgIf } from '@angular/common';
import { Component, signal } from '@angular/core';
import { LoadingService } from './loading.service';

@Component({
  selector: 'ui-loading',
  standalone: true,
  imports: [NgIf],
  templateUrl: './loading.component.html',
  styleUrl: './loading.component.css',
})
export class LoadingComponent {
  loading = signal<boolean>(true);
  constructor(private loadingService: LoadingService) {
    this.loading = this.loadingService.loading;
  }
}
